(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('sticky-atc .main-product-atc');
    if (!button || !document.body.classList.contains('ke-product-page')) return;
    const section = button.closest('sticky-atc').dataset.section;
    const original = document.getElementById(`ProductSubmitButton-${section}`);
    if (!original) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (original.disabled || original.getAttribute('aria-disabled') === 'true') return;
    const form = original.form;
    if (form && !form.checkValidity()) {
      original.scrollIntoView({ behavior: 'smooth', block: 'center' });
      form.reportValidity();
      return;
    }
    original.click();
  }, true);
})();
